import React from 'react'

function TicketsDashboard() {
  return (
    <div>TicketsDashboard</div>
  )
}

export default TicketsDashboard